export default {
    agreeTOS:
        "I agree to MakeLeaps' <0>Terms of Service</0> and I have read the <1>Privacy Policy</1>",
    building: 'Building',
    businessType: 'Business Type',
    cancel: 'Cancel',
    city: 'City / ward',
    clear: 'Clear',
    companyEmail: 'Business email',
    companyName: 'Company name or Business name',
    companyPhoneNumber: 'Company phone number',
    confirm: 'Confirm',
    country: 'Country name',
    create: 'Create',
    delete: 'Delete',
    emailAddress: 'Email Address',
    emailAddressHelpText: 'e.g. name@example.com',
    employees: 'Numbers of employees',
    error: {
        emailInvalid: 'Please enter a valid email',
        error: 'Error',
        fieldIsRequired: 'Please complete this required field.',
    },
    faxNumber: 'Fax number',
    firstName: 'First name',
    goBack: 'Go back',
    lastName: 'Last name',
    neighborhood: 'Neighborhood',
    noOptions: 'No options available',
    ok: 'OK',
    password: 'Password',
    passwordConfirm: 'Confirm Password',
    phoneNumber: 'Phone number',
    postcode: 'Postcode',
    postcodeAutoFill: 'Auto-fill',
    prefecture: 'Prefecture',
    registrationCode: 'Registration Code',
    required: 'Required',
    save: 'Save',
    select: 'Select',
    selectDate: 'Select date',
    selectDateTime: 'Select date and time',
    submit: 'Submit',
    time: 'Time',
    today: 'Today',
    username: 'Username',
    workEmail: 'Work email',
};
